import React, {Component} from 'react';

import {
    SplitterResizeEndEvent,
    Splitter,
    SplitterPanel,
    SplitterPassThroughOptions
} from 'primereact/splitter';

const defaultProps = {
    contentClassName: 'yn-content-panel-container' as string,

    menuClassName: 'yn-content-menu-container' as string,

    /**
     * The width of the menu on the left side in percent.
     */
    menuWidth: 20 as number,

    /**
     * The minimal width of the menu on the left side in percent.
     */
    minMenuWidth: 15 as number,

    /**
     * The maximal width of the menu on the left side in percent.
     */
    maxMenuWidth: 30 as number
};

type DefaultProps = typeof defaultProps;

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * The content of the menu panel (left panel).
     */
    menu : JSX.Element;

    /**
     * Style to be applied to the menu wrapper.
     */
    menuStyle? : CssStyle;

    /**
     * the content of the content panel (right panel).
     */
    content : JSX.Element;

    /**
     * Style to be applied to the content wrapper.
     */
    contentStyle? : CssStyle;

    /**
     * Callback to invoke if the menu width changes.
     *
     * @param {Number} width
     */
    onMenuWidthChange? : ( width : number ) => void;

    /**
     * Callback to invoke if the menu width changes.
     *
     * @param {Number} width
     */
    onMenuScroll? : () => void;

    pt? : SplitterPassThroughOptions;

    gutterSize? : number;
};

//type AllProps = Props & Partial<DefaultProps>;
type PropsWithDefaults = Props & DefaultProps;

type State = {
    menuWidth : number;
}

/**
 * Panel with a resizeable menu on the left side
 */
class ResizeableRightMenuPanel extends Component<PropsWithDefaults, State> {

    static defaultProps = defaultProps;

    menuRef? : SplitterPanel | null;

    /**
     * @param props
     */
    constructor( props : PropsWithDefaults ) {
        super( props );

        // init state
        this.state = {
            menuWidth: props.menuWidth
        };

        // bind event handlers
        this.onSplitterResizeEnd = this.onSplitterResizeEnd.bind( this );
    }

    componentDidMount() {
        const menuPanel = document.getElementById( `${this.props.uid}_menuContentSplitter` )?.children?.[ 0 ];
        if ( menuPanel && this.props.onMenuScroll ) {
            menuPanel.addEventListener( 'scroll', this.props.onMenuScroll );
        }
    }

    /**
     * Handler for splitter resize end.
     *
     * @private
     */
    onSplitterResizeEnd( event : SplitterResizeEndEvent ) {
        if ( event.sizes?.length ) {
            this.setState( { menuWidth: event.sizes[ 1 ] } );

            if ( this.props.onMenuWidthChange ) {
                this.props.onMenuWidthChange( event.sizes[ 1 ] );
            }
        }
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  content,
                  contentClassName,
                  contentStyle,
                  gutterSize,
                  maxMenuWidth,
                  menu,
                  menuClassName,
                  menuStyle,
                  minMenuWidth,
                  pt,
                  uid
              } = this.props,
              {
                  menuWidth
              } = this.state;

        return <Splitter
            key={`${uid}_rightMenuContentSplitter`}
            id={`${uid}_rightMenuContentSplitter`}

            stateKey={`${uid}_rightMenuContentSplitter`}

            className="yn-flex-layout-child yn-content yn-splitter-left"
            style={{ zIndex: 4 }}
            onResizeEnd={this.onSplitterResizeEnd}
            pt={pt}
            gutterSize={gutterSize ?? 4}
        >
            <SplitterPanel
                className={contentClassName}
                size={100 - menuWidth}
                minSize={100 - maxMenuWidth}
                style={contentStyle}
            >
                {content}
            </SplitterPanel>
            <SplitterPanel
                className={menuClassName}
                size={menuWidth}
                minSize={minMenuWidth}
                style={menuStyle}
            >
                {menu}
            </SplitterPanel>
        </Splitter>;
    }
}

export default ResizeableRightMenuPanel;
